import { useState, useEffect } from 'react';
import ChatBot from 'react-simple-chatbot';
import './style.scss';
import { ThemeProvider } from 'styled-components';

import DragAndDrop from './DragAndDrop';
import SendEmail from './SendEmail';
import WaitForScreen from './WaitForScreen';
import WaitForVideo from './WaitForVideo';
import botLogo from '../../assets/img/botLogo.png';

import { useTranslation } from 'react-i18next';

import { setDescription, clearUrls, getChatBotShow } from '../../redux/slices/chatbotSlice';

import { useDispatch, useSelector } from 'react-redux';
import { isMobile, isSafari } from 'react-device-detect';

import { useDetectKeyboardOpen } from '../../shared/hooks/use-detect-keyboard-open';

const Chatbot = () => {
  const chatbotShow = useSelector(getChatBotShow);
  const [openBot, setOpenBot] = useState(false);
  const [checkDevice, setCheckDevice] = useState(false);
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const isKeyboardVisible = useDetectKeyboardOpen();
  const theme = {
    headerBgColor: '#9cdffc',
    background: '#f5f8fb',
    botBubbleColor: '#9cdffc',
    userBubbleColor: '#fff',
  };

  const handleCloseBot = () => {
    dispatch(clearUrls());
    setOpenBot(false);
  };

  useEffect(() => {
    handleCloseBot();
  }, [i18n.language]);

  useEffect(() => {
    if (isMobile || isSafari) {
      setCheckDevice(false);
    } else {
      setCheckDevice(true);
    }
  }, []);

  const steps = checkDevice
    ? [
        {
          id: '0',
          message: t('botHi'),
          trigger: '1',
        },
        {
          id: '1',
          message: t('botFoundBug'),
          trigger: 'problem',
        },
        {
          id: 'problem',
          user: true,
          validator: value => {
            if (value && value.length > 10) {
              dispatch(setDescription(value));
              return true;
            }
            return t('botSmallString');
          },
          trigger: '3',
        },
        {
          id: '3',
          message: t('botChooseMethod'),
          trigger: '4',
        },
        {
          id: '4',
          options: [
            { value: 1, label: t('botMethodBrowser'), trigger: 'browser' },
            { value: 2, label: t('botMethodInput'), trigger: 'input' },
          ],
        },
        {
          id: 'input',
          component: <DragAndDrop />,
          waitAction: true,
        },
        {
          id: 'browser',
          options: [
            { value: 1, label: t('botVideo'), trigger: 'video' },
            { value: 2, label: t('botScreen'), trigger: 'screen' },
          ],
        },
        {
          id: 'video',
          component: <WaitForVideo />,
          waitAction: true,
          asMessage: true,
        },
        {
          id: 'screen',
          component: <WaitForScreen />,
          waitAction: true,
          asMessage: true,
        },
        {
          id: '6',
          options: [
            { value: 1, label: t('botMoreMedia'), trigger: '4' },
            { value: 2, label: t('botNo'), trigger: '8' },
          ],
        },
        {
          id: '8',
          component: <SendEmail />,
          waitAction: true,
          asMessage: true,
        },
        {
          id: '9',
          message: t('botThanks'),
          trigger: '10',
        },
        {
          id: '10',
          message: '1',
          delay: 2000,
          end: true,
        },
        {
          id: 'no-screen',
          message: t('botNoScreen'),
          trigger: '0',
        },
      ]
    : [
        {
          id: '0',
          message: t('botHi'),
          trigger: '1',
        },
        {
          id: '1',
          message: t('botFoundBug'),
          trigger: 'problem',
        },
        {
          id: 'problem',
          user: true,
          validator: value => {
            if (value && value.length > 10) {
              dispatch(setDescription(value));
              return true;
            }
            return t('botSmallString');
          },
          trigger: '4',
        },
        {
          id: '4',
          message: t('botAddMedia'),
          trigger: 'input',
        },
        {
          id: 'input',
          component: <DragAndDrop />,
          waitAction: true,
        },
        {
          id: '6',
          options: [
            { value: 1, label: t('botMoreMedia'), trigger: '4' },
            { value: 2, label: t('botNo'), trigger: '8' },
          ],
        },
        {
          id: '8',
          component: <SendEmail />,
          waitAction: true,
          asMessage: true,
        },
        {
          id: '9',
          message: t('botThanks'),
          trigger: '10',
        },
        {
          id: '10',
          message: '1',
          delay: 2000,
          end: true,
        },
        {
          id: 'no-screen',
          message: t('botNoScreen'),
          trigger: '0',
        },
      ];

  return (
    !isKeyboardVisible &&
    chatbotShow && (
      <div>
        {JSON.parse(localStorage.getItem('user')) && (
          <div className="bot-wrapper">
            <div className="bot-content">
              <button className={`openButton ${!openBot ? 'open' : 'close'}`} onClick={() => setOpenBot(true)}>
                <img src={botLogo} alt="bot"></img>
              </button>
              {openBot && (
                <div className={`${openBot ? 'open' : 'close'}`}>
                  <button className="closeButton" onClick={handleCloseBot}>
                    X
                  </button>
                  <ThemeProvider theme={theme}>
                    <ChatBot
                      headerTitle="Логос"
                      steps={steps}
                      userAvatar={JSON.parse(localStorage.getItem('user')).photoURL}
                      botAvatar={botLogo}
                      placeholder={t('botPlaceholder')}
                      handleEnd={handleCloseBot}
                    />
                  </ThemeProvider>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default Chatbot;
